import searchService from "@/services/search.service"
import { getApprenticeshipTypeName } from "@/helpers/job"
import { classMapping, graduationMapping } from "@/helpers/mapping"

let interestMessage = null
let ctx
export default function (context) {
    ctx = context
    return [
        {
            id: "firstname",
            next: "lastname",
            body: "Wie lautet dein Vorname?",
            inputLabel: "Vorname",
            inputType: "text",
            defaultData: function () {
                return ctx.$auth.user?.trainee?.firstname
            },
            hide: function () {
                return !!ctx.$auth.user?.trainee?.firstname
            },
            validator: (value) => !!value,
        },
        {
            id: "lastname",
            next: "region_pre",
            body: function () {
                if (ctx.formData.firstname.data) {
                    return `Hey ${ctx.formData.firstname.data} 👋
Wie lautet dein Nachname?`
                }
                return "Wie lautet dein Nachname?"
            },
            inputLabel: "Nachname",
            inputType: "text",
            defaultData: function () {
                return ctx.$auth.user?.trainee?.lastname
            },
            hide: function () {
                return !!ctx.$auth.user?.trainee?.firstname
            },
            validator: (value) => !!value,
        },
        {
            id: "region_pre",
            next: "region",
            body: function () {
                const displayedJob = ctx.$store.getters["job/displayedJob"]
                const business = displayedJob.business
                const typeText =
                    displayedJob.type_id === 2
                        ? "ein Praktikum"
                        : getApprenticeshipTypeName(displayedJob)
                const cp = business.public_contact_person
                if (cp) {
                    const cpPronoun =
                        cp.gender === "Frau"
                            ? "deine Ansprechpartnerin"
                            : "dein Ansprechpartner"
                    return `Schön dich kennen zu lernen. Ich bin ${cp.firstname} ${cp.lastname}, ${cpPronoun} für ${typeText} bei ${business.name}.`
                }
                return `Schön dich kennen zu lernen. Ich bin dein Kontakt für ${typeText} bei ${business.name}.`
            },
            noReply: true,
            hide: function () {
                return ctx.$auth.user?.trainee?.primary_address?.city
            },
        },
        {
            id: "region",
            next: "class",
            body: "Verrate mir bitte noch woher du kommst.",
            inputLabel: "Ort",
            inputType: "region",
            suggestions: async function () {
                let cities = await searchService.getCities()
                cities = cities.splice(0, 5).map((city) => ({
                    text: city.name,
                    value: city,
                    callback: async function () {
                        const loc = await searchService.getLocationFromSlug(
                            city.slug
                        )
                        const text = loc.name
                        ctx.currentMessage = text
                        ctx.setProgress(text, loc)
                        if (ctx.isEditMode) {
                            ctx.updateMessage(text)
                        } else {
                            ctx.sendMessage(text)
                        }
                    },
                }))
                cities.push({
                    text: "andere...",
                    callback: function () {
                        ctx.$refs.input?.openMenu()
                    },
                    animate: false,
                })
                return cities
            },
            defaultData: function () {
                const primaryAddress = ctx.$auth.user?.trainee?.primary_address
                if (!primaryAddress?.city) return
                return {
                    text: primaryAddress.city,
                    value: primaryAddress,
                }
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.primary_address?.city
            },
        },
        {
            id: "class",
            next: "school",
            body: "In welche Jahrgangsstufe gehst du?",
            suggestions: classMapping,
            defaultData: function () {
                return ctx.$auth.user?.trainee?.class
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.class
            },
        },
        {
            id: "school",
            next: "graduation",
            body: function () {
                if (ctx.formData.class.data == "-1") {
                    return "Alles klar. \nUnd welche Schule hast du besucht?"
                }
                return "Alles klar. \nUnd welche Schule besuchst du?"
            },
            inputLabel: "Schule",
            inputType: "school",
            suggestions: async function () {
                const location = ctx.formData["region"]?.data
                if (!location) return
                let suggestions = await searchService.searchBaseSchool({
                    limit: 4,
                    latitude: location.latitude ?? location.lat ?? null,
                    longitude: location.longitude ?? location.lng ?? null,
                })

                if (!suggestions?.length || suggestions.length == 0) return [] // empty result / error
                suggestions = suggestions.map((school) => ({
                    text: school.name,
                    value: school,
                }))
                suggestions.push({
                    text: "andere...",
                    callback: function () {
                        ctx.$refs.input?.openSearch()
                    },
                    animate: false,
                })
                return suggestions
            },
            defaultData: function () {
                return ctx.$auth.user?.trainee?.school_base?.name
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.school_base?.name
            },
        },
        {
            id: "graduation",
            next: "message",
            body: function () {
                if (ctx.formData.class.data == "-1") {
                    return "Welchen Schulabschluss hast du?"
                }
                return "Welchen Schulabschluss wirst du voraussichtlich haben?"
            },
            options: graduationMapping,
            inputType: "select",
            inputLabel: "Schulabschluss",
            suggestions: function () {
                let graduationTypes = getGraduationSuggestions.call(ctx)
                graduationTypes.push({
                    text: "andere...",
                    callback: function () {
                        ctx.$refs.input?.openMenu()
                    },
                    animate: false,
                })
                return graduationTypes
            },
            defaultData: function () {
                let mapping = graduationMapping.find(
                    (graduation) =>
                        graduation.value ===
                        ctx.$auth.user?.trainee?.highest_graduation
                )
                if (mapping) {
                    return {
                        value: mapping.value,
                        text: mapping.text,
                    }
                }
                return undefined
            },
            hide: function () {
                return ctx.$auth.user?.trainee?.highest_graduation
            },
        },
        {
            id: "message",
            next: "documents_pre",
            body: function () {
                if (ctx.$auth.loggedIn) {
                    return "Möchtest du deiner Anfrage noch eine Nachricht anhängen?"
                }
                return "Fast geschafft! Es fehlt nur noch eine persönliche Nachricht.\nDazu kannst du diese Vorlage nutzen, oder eine eigene Nachricht formulieren."
            },
            options: [],
            inputLabel: "Dein Anschreiben",
            inputType: "text",
            suggestions: function () {
                interestMessage = getInterestMessage.call(ctx)
                return [
                    {
                        text: interestMessage,
                        callback: function () {
                            ctx.currentMessage = interestMessage
                            const message =
                                ctx.messages[ctx.messages.length - 1]
                            ctx.$set(message, "suggestions", [])
                        },
                        animate: false,
                    },
                    {
                        text: "eigene Nachricht schreiben",
                        callback: function () {
                            ctx.currentMessage = ""
                            ctx.$refs.input?.focus()
                            const message =
                                ctx.messages[ctx.messages.length - 1]
                            ctx.$set(message, "suggestions", [])
                        },
                        animate: false,
                    },
                ]
            },
            validator: (value) =>
                !!value || "Wähle oder schreibe ein Anschreiben",
        },
        {
            id: "documents_pre",
            next: "documents",
            body: "Wenn du möchtest, kannst du noch Unterlagen wie deinen Lebenslauf und dein Zeugnis hinzufügen.",
            noReply: true,
        },
        {
            id: "documents",
            next: "completed",
            actionMessage: true,
            type: "form",
            name: "JobInterestDocuments",
            body: {
                business: ctx.$store.getters["job/displayedJob"].business,
                initialFiles: ctx.formData.documents?.data,
                data: ctx.formData[ctx.currentQuestionId],
            },
            sender_id: ctx.$auth.user?.id ?? 0,
            listeners: {
                accept: function () {
                    if (ctx.isEditMode) {
                        const message = ctx.currentMessage
                        let messageToEditIndex = ctx.messages.findIndex(
                            (message) =>
                                message.questionId === ctx.currentQuestionId &&
                                message.sender_id !== null
                        )
                        let messageToEdit = ctx.messages[messageToEditIndex]
                        messageToEdit.body.data = message
                        ctx.$set(
                            ctx.messages,
                            messageToEditIndex,
                            messageToEdit
                        )
                        ctx.currentQuestionId = ctx.storedQuestionId
                        ctx.resetCurrentMessage()
                        ctx.isEditMode = false
                    } else {
                        ctx.nextQuestion()
                    }
                },
                update: function (files) {
                    ctx.setProgress(files)
                },
            },
        },
        {
            id: "completed",
            next: null,
            body: function () {
                if (ctx.$auth.loggedIn) {
                    return "Super, das ist auch schon alles! 🙌\nWir werden deine Anfrage direkt über Oabat per Chat beantworten."
                }
                return "Super, das ist auch schon alles! 🙌\nWir werden deine Anfrage direkt über Oabat per Chat beantworten.\nGib dazu einfach deine Telefonnummer ein oder nutze deine E-Mail.\nDu kannst dich so auch wieder einloggen."
            },
            noReply: true,
        },
    ]
}

function getGraduationSuggestions() {
    let suggestions = []
    const school = ctx.formData["school"].text.toLowerCase()
    if (school.includes("gymnasium")) {
        suggestions.push({
            text: "Abitur",
            value: "abi",
        })
        suggestions.push({
            text: "Bachelor",
            value: "bachelor",
        })
        suggestions.push({
            text: "Master",
            value: "master",
        })
    } else if (school.includes("berufs") || school.includes("fach")) {
        suggestions.push({
            text: "Fachabitur",
            value: "fos",
        })
        suggestions.push({
            text: "Abitur",
            value: "abi",
        })
        suggestions.push({
            text: "Bachelor",
            value: "bachelor",
        })
    } else {
        suggestions.push({
            text: "Mittlerer Schulabschluss",
            value: "mittel",
        })
        suggestions.push({
            text: "Qualifizierender Hauptschulabschluss",
            value: "quali",
        })
        suggestions.push({
            text: "Mittelschulabschluss",
            value: "main",
        })
    }
    return suggestions
}

function getInterestMessage() {
    const job = ctx.$store.getters["job/displayedJob"]
    const formData = ctx.formData
    const school = formData["school"].text
    let schoolString = `habe ${
        isGymnasium(school) ? "das" : "die"
    } ${school} besucht`
    if (formData["class"].data !== "none" && formData["class"].data !== "-1") {
        schoolString = `besuche derzeit die ${formData["class"].data}. Klasse ${
            isGymnasium(school) ? "des" : "der"
        } ${school}`
    }

    let salutation = "Sehr geehrte Damen und Herren"
    if (job.business.public_contact_person) {
        const cp = job.business.public_contact_person
        const prefix = cp.gender === "Herr" ? "geehrter" : "geehrte"
        salutation = `Sehr ${prefix} ${cp.gender} ${cp.firstname} ${cp.lastname}`
    }

    return `${salutation},

Ich bin ${formData["firstname"].text} ${formData["lastname"].text} und ${schoolString}.
Ich habe großes Interesse an Ihrer Stelle und würde Sie gerne kennenlernen.
Über die Chance, Sie bei einem Vorstellungsgespräch zu überzeugen, würde ich mich sehr freuen.

Mit freundlichen Grüßen
${formData["firstname"].text} ${formData["lastname"].text}`
}

function isGymnasium(text) {
    return text.toLowerCase().includes("gymnasium")
}
